"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDropdownSelection = void 0;
var _reactUi = require("@100mslive/react-ui");
var useDropdownSelection = function useDropdownSelection() {
  var _useTheme = (0, _reactUi.useTheme)(),
    themeType = _useTheme.themeType;
  return themeType === "dark" ? "$primaryDark" : "$grayLight";
};
exports.useDropdownSelection = useDropdownSelection;